import {
    appItem,
    type BreadcrumbDataKey,
    type BreadcrumbPath,
    createDroneItem,
    createItem,
    createLocationItem,
    createOrganizationItem,
    definePath,
    dockItem,
    docksItem,
    droneItem,
    dronesItem,
    editItem,
    fileItem,
    flightItem,
    flightsItem,
    globalAppsItem,
    imageItem,
    imagesItem,
    livestreamItem,
    locationAppsItem,
    locationItem,
    locationsItem,
    missionItem,
    missionsItem,
    nerdItem,
    organizationItem,
    organizationsItem,
    payloadItem,
    payloadsItem,
    resultsItem,
    routineItem,
    routinesItem,
    settingsItem,
    startItem,
    taskAppSettingsItem,
    taskItem,
    tasksItem,
} from "./breadcrumbItems";

const organizationPath = [organizationsItem, organizationItem] as const;
const locationListPath = [...organizationPath, locationsItem] as const;
const locationPath = [...organizationPath, locationItem] as const;
const taskListPath = [...locationPath, tasksItem] as const;
const taskPath = [...taskListPath, taskItem] as const;
const dockListPath = [...locationPath, docksItem] as const;
const dockPath = [...dockListPath, dockItem] as const;
const droneListPath = [...locationPath, dronesItem] as const;
const dronePath = [...droneListPath, droneItem] as const;
const missionListPath = [...locationPath, missionsItem] as const;
const compactMissionPath = [...locationPath, missionItem] as const;
const missionPath = [...missionListPath, missionItem] as const;
const flightListPath = [...locationPath, flightsItem] as const;
const compactFlightPath = [...locationPath, flightItem] as const;
const flightPath = [...flightListPath, flightItem] as const;
const routineListPath = [...locationPath, routinesItem] as const;
const routinePath = [...routineListPath, routineItem] as const;
const globalAppsPath = [organizationsItem, globalAppsItem] as const;

export const breadcrumbPaths = {
    organization: definePath(organizationPath),
    organizationSettings: definePath([...organizationPath, settingsItem]),
    locationList: definePath(locationListPath),
    location: definePath(locationPath),
    locationSettings: definePath([...locationPath, settingsItem]),
    locationCreate: definePath([...organizationPath, createLocationItem]),
    organizationCreate: definePath([organizationsItem, createOrganizationItem]),
    taskList: definePath(taskListPath),
    task: definePath(taskPath),
    taskSettings: definePath([...taskPath, settingsItem]),
    taskAppSettings: definePath([...taskPath, taskAppSettingsItem]),
    dockList: definePath(dockListPath),
    dock: definePath(dockPath),
    dockCreate: definePath([...dockListPath, createItem]),
    dockSettings: definePath([...dockPath, settingsItem]),
    droneList: definePath(droneListPath),
    drone: definePath(dronePath),
    droneCreate: definePath([...locationPath, createDroneItem]),
    droneSettings: definePath([...dronePath, settingsItem]),
    droneNerd: definePath([...dronePath, nerdItem]),
    droneLivestream: definePath([...dronePath, livestreamItem]),
    missionList: definePath(missionListPath),
    mission: definePath(missionPath),
    flightList: definePath(flightListPath),
    flight: definePath(flightPath),
    locationImages: definePath([...locationPath, imagesItem]),
    missionImages: definePath([...compactMissionPath, imagesItem]),
    flightImages: definePath([...compactFlightPath, imagesItem]),
    image: definePath([...compactMissionPath, imagesItem, imageItem]),
    results: definePath([...locationPath, resultsItem]),
    resultFile: definePath([...compactMissionPath, fileItem]),
    routines: definePath(routineListPath),
    routineCreate: definePath([...routineListPath, createItem]),
    routine: definePath(routinePath),
    routineSettings: definePath([...routinePath, editItem]),
    locationApps: definePath([...locationPath, locationAppsItem]),
    locationAppSettings: definePath([
        ...locationPath,
        locationAppsItem,
        appItem,
        settingsItem,
    ]),
    globalAppSettings: definePath([...globalAppsPath, appItem, settingsItem]),
    globalAppCreate: definePath([...globalAppsPath, createItem]),
    payloadList: definePath([organizationsItem, payloadsItem]),
    payload: definePath([organizationsItem, payloadsItem, payloadItem]),
    start: definePath([...locationPath, startItem]),
} satisfies Record<string, BreadcrumbPath<BreadcrumbDataKey>>;
